import React from "react";
import { uniqueId } from "../../../utils/generalLiveCenter";

// import "../table/GroupStage.scss";

const TableGroup = ({ groups, disable = false }) => {
  return (
    <div className={`group_stages_wrp ${disable ? "d-none" : ""}`}>
      <ul className="group_stages">
        {groups?.length
          ? groups?.map((group, ind) => (
            <li key={uniqueId(ind)}>
              <span
                className="stg_circle"
                style={{ backgroundColor: group?.color }}
              />
              <span className="stg_test">{group?.name}</span>
            </li>
          ))
          : ""}
      </ul>
    </div>
  );
};

export default TableGroup;
